
import { ProductList } from "./charity/ProductList";
import { useChurchBranding } from "@/contexts/ChurchBrandingContext";
import { useTheme } from "@/components/ui/theme-provider";

export function CharityProducts() {
  const { branding } = useChurchBranding();
  const { theme } = useTheme();
  
  const getTitleColor = () => {
    if (branding?.primaryColor) {
      return branding.primaryColor;
    }
    return theme === "dark" ? "hsl(var(--app-accent))" : "#1a365d";
  };

  const getDescriptionColor = () => {
    return theme === "dark" ? "text-app-text-secondary" : "text-muted-foreground";
  };

  const getThankYouSectionClasses = () => {
    if (theme === "dark") {
      return "mt-12 rounded-lg p-6 md:p-8 animate-fade-in bg-app-surface/50 backdrop-blur-sm border-t-4 border-app-accent";
    }
    return "mt-12 rounded-lg p-6 md:p-8 animate-fade-in";
  };

  const getThankYouSectionStyle = () => {
    if (theme === "dark") {
      return {};
    }
    return { 
      background: "linear-gradient(109.6deg, rgba(223,234,247,1) 11.2%, rgba(244,248,252,1) 91.1%)",
      borderTop: `3px solid ${branding?.primaryColor || "#1a365d"}`
    };
  };

  const getThankYouTextColor = () => {
    return theme === "dark" ? "text-app-text-secondary" : "text-gray-700";
  };

  const getCrossColor = () => {
    return theme === "dark" ? "text-app-text-muted" : "text-gray-500";
  };

  const getDividerColor = () => {
    return theme === "dark" ? "bg-app-border" : "bg-gray-300";
  };
  
  return (
    <div className="container max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold text-center mb-4 transition-colors duration-300" 
          style={{ color: getTitleColor() }}>
        {branding?.churchName ? `Support ${branding.churchName}` : "Support Our Ministry"}
      </h1>
      <p className={`text-center ${getDescriptionColor()} mb-6 max-w-2xl mx-auto transition-colors duration-300`}>
        Help spread faith and connection through our NFC-enabled prayer bracelets
      </p>
      <ProductList />
      
      <div className={getThankYouSectionClasses()} 
           style={getThankYouSectionStyle()}>
        <div className="text-center space-y-4">
          <h3 className="text-xl md:text-2xl font-semibold font-grace transition-colors duration-300" 
              style={{ color: getTitleColor() }}>
            Thank You for Your Support
          </h3>
          <p className={`${getThankYouTextColor()} max-w-2xl mx-auto font-grace leading-relaxed transition-colors duration-300`}>
            Your generosity makes it possible for us to continue our mission of spreading hope and faith
            through these prayer bracelets. Each donation directly impacts lives and strengthens our
            community of believers.
          </p>
          <div className="my-4 flex items-center justify-center">
            <div className={`h-px w-12 ${getDividerColor()} transition-colors duration-300`}></div>
            <div className="mx-4">
              <span className={`text-sm ${getCrossColor()} transition-colors duration-300`}>✝</span>
            </div>
            <div className={`h-px w-12 ${getDividerColor()} transition-colors duration-300`}></div>
          </div>
          <p className={`text-sm ${getDescriptionColor()} mt-2 transition-colors duration-300`}>
            100% of donations go directly to providing NFC prayer bracelets to those in need
          </p>
        </div>
      </div>
    </div>
  );
}
